// extracted by mini-css-extract-plugin
module.exports = {"content":"Panel_content__FR5nb","open":"Panel_open__x7PVQ","icon":"Panel_icon__HkQwu","arrow":"Panel_arrow__Bz13D"};